import { bindCsSubTrackingListeners } from '../components/cs-subscription/cs-subscription-tracking';
import {
	buildCsSubPackages,
	showCsSubPrebuiltPackage,
} from '../components/cs-subscription/cs-subscription-packages';
import { getActiveSubscriptions } from '../components/cs-subscription/cs-subscription-api';
import { showThankyouMessage } from '../components/cs-subscription/cs-subscription-common';

export default function CsSubscription(uuid = null) {
	init((uuid = uuid ? uuid : null));

	async function init(uuid = null) {
		window?.Bark?.triggerHotjarRecording('cs_subscription_self_serve_page');
		await showThankyouMessageOrPackages(uuid);
		bindPageListeners();
		bindCsSubTrackingListeners();
	}

	function bindPageListeners() {
		$('[data-toggle="tooltip"]').tooltip({ container: '#cs-subscription-landing' });
	}

	async function showThankyouMessageOrPackages(uuid) {
		const activeSubscriptions = await getActiveSubscriptions();
		if (activeSubscriptions?.data?.subscriptions?.length) {
			showThankyouMessage();
		} else if (uuid) {
			await showCsSubPrebuiltPackage(uuid);
		} else {
			await buildCsSubPackages();
			setTimeout(() => $('#custom-pack-n-leads').focus(), 500);
		}
		$('#cs-subscription-landing').removeClass('invisible');
		return;
	}
}
